<template>
  <!-- <NavBar v-if="isContentLoaded" /> -->
  <router-view />
  <Footer v-if="isContentLoaded" />
</template>

<script>
// import NavBar from "@/components/NavBar/NavBar.vue";
import Footer from "@/components/Footer/Footer.vue";
import { ref } from "vue";
import { useRouter } from "vue-router";
export default {
  name: "App",
  components: {
    // NavBar,
    Footer,
    // MainBody,
  },
  setup() {
    const isContentLoaded = ref(false);
    const router = useRouter();

    // 全局路由守卫监听路由加载完成
    router.beforeEach((to, from, next) => {
      isContentLoaded.value = false; // 路由切换时隐藏 Footer
      next();
    });

    router.afterEach(() => {
      isContentLoaded.value = true; // 路由加载完成后显示 Footer
    });

    return {
      isContentLoaded,
    };
  },
};
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
